import { Controller, useFormContext } from "react-hook-form";

import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import InputLabel from "@mui/material/InputLabel";
import { Theme, SxProps } from "@mui/material/styles";
import FormHelperText from "@mui/material/FormHelperText";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import FormControl, { FormControlProps } from "@mui/material/FormControl";
import { useEffect } from "react";

// ----------------------------------------------------------------------
export function RHFSelect({
  name,
  native,
  maxHeight = 220,
  helperText,
  children,
  PaperPropsSx,
  ...other
}) {
  const { control } = useFormContext();
//   const isMobile = useResponsive("down", "sm");

  return (
    <Controller
      name={name}
      control={control}
      
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          select
          fullWidth
          value={field.value || ""}
          onChange={(e) => field.onChange(e.target.value)}
          sx={{
            "& .MuiInputBase-root": {
              height: "50px !important",
              backgroundColor: "#fff",
              color:    'rgba(81, 92, 99, 1)', 
              container:'revert-layer'
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor:    'rgba(40, 126, 173, 0.12)', // Red border on error
              },
              '&:hover fieldset': {
                borderColor:    'rgba(40, 126, 173, 0.12)', // Red border on hover if error
              },
              '&.Mui-focused fieldset': {
                borderWidth: 1,
                borderColor:    'rgba(40, 126, 173, 0.12)', // Red border on focus if error
              },
            },
            '& .MuiInputBase-input': {
              color: 'rgba(81, 92, 99, 1)', // Change text color here
              fontSize: '15px', // Font size for input conten
            },
            '& .MuiInputBase-input::placeholder': {
              color: 'rgba(81, 92, 99, 0.1)', 
              fontSize: '14px', // Font size for input conten
            },
          }}
          InputLabelProps={{
            style:{
              fontSize:'15px',
              color:'rgba(81, 92, 99, 0.8)'
            }
          }}
          SelectProps={{
            native,
            MenuProps: {
              PaperProps: {
                sx: {
                  ...(!native && {
                    maxHeight:
                      typeof maxHeight === "number" ? maxHeight : "unset",
                  }),
                  ...PaperPropsSx,
                },
              },
            },
            sx: { textTransform: "capitalize" },
          }}
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}>
          {children}
        </TextField>
      )}
    />
  );
}

// ----------------------------------------------------------------------

export function RHFMultiSelect({
  name,
  chip,
  label,
  options,
  checkbox,
  placeholder,
  helperText,
  ...other
}) {
  const { control } = useFormContext();

  const renderValues = (selectedIds) => {
    const selectedItems = options.filter((item) =>
      selectedIds.includes(item.value)
    );

    if (!selectedItems.length && placeholder) {
      return <Box sx={{ color: "text.disabled" }}>{placeholder}</Box>;
    }

    if (chip) {
      return (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
          {selectedItems.map((item) => (
            <Chip key={item.value} size="small" label={item.label} />
          ))}
        </Box>
      );
    }

    return selectedItems.map((item) => item.label).join(", ");
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl sx={{height:'52px !important'}} error={!!error} {...other}>
          {label && <InputLabel id={name}> {label} </InputLabel>}

          <Select
            {...field}
            multiple
            displayEmpty={!!placeholder}
            id={`multiple-${name}`}
            labelId={name}
            label={label}
            renderValue={renderValues}>
            {options.map((option) => {
              const selected = field.value.includes(option.value);

              return (
                <MenuItem key={option.value} value={option.value}>
                  {checkbox && (
                    <Checkbox size="small" disableRipple checked={selected} />
                  )}

                  {option.label}
                </MenuItem>
              );
            })}
          </Select>

          {(!!error || helperText) && (
            <FormHelperText error={!!error}>
              {error ? error?.message : helperText}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}